










































































import ApplicationCard from "@/components/global/ApplicationCard.vue";
import PriceOptimizerModule from "@/store/modules/price-optimizer";
import { DashboardState } from "@/models";
import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";

const priceOptimizer = namespace(PriceOptimizerModule.name);

@Component({
  name: "DashboardAlerts",
  components: {
    ApplicationCard
  }
})

export default class DashboardAlerts extends Vue {
  // ===== Store ===== //
  @State("dashboard") public dashboard!: DashboardState;
  @priceOptimizer.Action("commitSavedSearchId") public commitSavedSearchId!: (searchId: number) => void;
  // ===== Methods ===== //
  public viewSavedSearch(searchId: number): void {
    this.commitSavedSearchId(searchId);
    this.$router.push({ name: "priceOptimizer" });
  }
}
